import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

// Don't forget to update CONNECT_ROUTES_SET in @atlassian/jira-common-constants/src/spa-routes
export const connectGeneralServiceDeskProjectRoute: InvariantJiraRoute = {
	name: 'connect-general-service-desk-project',
	path: '/plugins/servlet/ac/:addonKey/:moduleKey',
	query: [
		'mobile?!=true',
		'includeWebResources?!=true',
		'classifier?!=json',
		'project.key?',
		'project.id?',
		'project.key',
		'servicedesk.serviceDeskId',
	],
};
